/**
 * Les adresses fixes de l'espace tuteur, en un seul endroit : un adaptateur les lit (l'étape de la
 * charte du profil), les écrans aussi (les ressources, « Gérer une séance », le support).
 */

/** La page web de la charte d'engagement (`CompleteTutorProfileStepper`, l'étape 10 ; `TutorResources`). */
export const TUTOR_CHARTER_URL = "https://masteur.com/charte-dengagement"

/** Le WhatsApp de l'équipe quand `static-data` n'en sert pas — celui de l'ancien accueil du tuteur. */
export const SUPPORT_WHATSAPP_FALLBACK = "https://wa.me/message/FCOBQ6PCPMBJC1"
